import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMattermostComponent } from './simple-icons-mattermost.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMattermostComponent ],
    exports:      [ SimpleIconsMattermostComponent ],
    bootstrap:    []
})
export class SimpleIconsMattermostModule {}
